import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  canonicalPath?: string;
  jsonLd?: object[];
  type?: string;
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertJsonLd(data: object[]) {
  const existing = document.querySelectorAll('script[data-readdy-jsonld]');
  existing.forEach((n) => n.remove());
  data.forEach((item) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-readdy-jsonld', 'true');
    script.textContent = JSON.stringify(item);
    document.head.appendChild(script);
  });
}

export default function Seo({ title, description, canonicalPath, jsonLd, type = 'website' }: SeoProps) {
  useEffect(() => {
    document.title = title;
    upsertMeta('name', 'description', description);
    const basePath = __BASE_PATH__.split('/').filter(Boolean).join('/');
    const pathPrefix = basePath ? `/${basePath}` : '';
    const canonicalUrl = `${window.location.origin}${pathPrefix}${canonicalPath ?? window.location.pathname}`;
    upsertMeta('name', 'canonical', canonicalUrl);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', canonicalUrl);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:url', canonicalUrl);
    const existingLink = document.head.querySelector('link[rel="canonical"]');
    if (!existingLink) {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = canonicalUrl;
      document.head.appendChild(link);
    }
    if (jsonLd && jsonLd.length) {
      upsertJsonLd(jsonLd);
    }
  }, [title, description, canonicalPath, jsonLd, type]);

  return null;
}